import _ from "lodash";
import * as conferenceFormats from "../conferenceFormats/index.js";
import { getCareerAvailableYears } from "../lib/cvDataUtilities.js";
import { canUserViewConference } from "../lib/hierarchyUtilities.js";

export function getNewQuestionKey(conference) {
  let prefix = conference.id + "_q";
  let allKeys = conference.questions;
  let pattern = new RegExp(`${prefix}`);

  // get the questions just for this config and find the numbers so we can get the biggest
  // format ccNUMBER_qNUMBER
  let justGenerated = allKeys
    .filter((k) => k.match(pattern))
    .map((k) => k.match(/\d+/)[1]);
  let maxId =
    justGenerated.length == 0
      ? 0
      : Math.max(...justGenerated.map((n) => Number.parseInt(n)));

  return prefix + (maxId + 1);
}

export function getQuestionCaption(conferences, cvDef, key) {
  let return_value = key;
  if (cvDef && cvDef.career) {
    for (let year of Object.keys(cvDef.career)) {
      if (cvDef.career[year].questionCaptions) {
        for (let questionKey in cvDef.career[year].questionCaptions) {
          if (key == questionKey)
            return_value = cvDef.career[year].questionCaptions[key];
        }
      }
    }
  }

  for (let conference of Object.keys(conferences)) {
    if (_.isUndefined(conferences[conference].questionCaptions)) continue;
    conferences[conference].questions.forEach((questionKey, index) => {
      if (questionKey == key) {
        return_value = conferences[conference].questionCaptions[index];
      }
    });
  }

  return return_value;
}

export default function CareerConference({ contextConstants, contextState }) {
  let { user, cvOwner, conferences, formats, templateList, hierarchyNames } =
    contextConstants;
  let { format, newDef } = contextState;

  let confOptions = Object.values(conferences).filter(function (conf) {
    // if the CV format is generic, or the current format maps to the CC paths
    let matchesFormat =
      format == "generic" ||
      formats[format].filter({ requestedPaths: conf.paths }, templateList);
    let yearInfo = getCareerAvailableYears(newDef, conf, user, cvOwner);
    return (
      matchesFormat &&
      yearInfo.availableYears.length > 0 &&
      canUserViewConference(user, cvOwner, conf)
    );
  });

  return confOptions.map((conference, i) => {
    // Find associated conf format
    let confFormatName = conferenceFormats.list.includes(
      conference.format ?? ""
    )
      ? conference.format
      : "generic";
    let confFormat = conferenceFormats[confFormatName];

    let groupTitle = conference.paths
      .map((path) =>
        path
          .split("/")
          .map((n) => hierarchyNames[n])
          .join(" / ")
      )
      .join(", ");

    return {
      section: "career_" + i,
      field: "career",
      type: "custom",
      title: confFormat.tabTitle ?? "Career Conference",
      fullTitle:
        (confFormat.tabTitle ?? "Career Conference") + " - " + groupTitle,
      setup: function ({
        contextMethods,
        contextConstants,
        contextState,
        backend
      }) {
        confFormat.cvSetup({
          contextMethods,
          contextConstants,
          contextState,
          conference,
          backend
        });
      },
      noContentCheck: true,
      checkErrors: function () {
        return false;
      }
    };
  });
}
